import { pushHardware, pushMercuryHardware } from "../../state/ducks";
import { dispatch } from "../../state/store";
import { hardwareUtils } from "../../utils";
import httpClient from "../httpClient";

const petioleApiUrl = process.env.REACT_APP_PETIOLE_API_URL;
const mercuryApiUrl = process.env.REACT_APP_MERCURY_API_URL;

const LIMIT = 100;

const getRequestData = (endpoint, baseUrl = petioleApiUrl) => {
  const url = `${baseUrl}/${endpoint}`;

  return url;
};

const fetchHardwareBatch = async (nextToken) => {
  const baseUrl = getRequestData("hub/get-all-hubs");
  let url = `${baseUrl}?amount=${LIMIT}`;

  if (nextToken) {
    url = `${url}&nextToken=${nextToken}`;
  }

  const result = await httpClient.get(url);

  return result;
};

const fetchMercuryHardwareBatch = async (offset) => {
  const baseUrl = getRequestData("router", mercuryApiUrl);
  let url = `${baseUrl}?limit=${LIMIT}`;

  if (offset) {
    url = `${url}&offset=${offset}`;
  }

  const result = await httpClient.get(url);

  return result;
};

const fetchHardware = async () => {
  let nextToken = "";

  while (nextToken !== null) {
    const result = await fetchHardwareBatch(nextToken);

    const hubs = result?.data?.hubs;
    const token = result?.data?.nextToken ?? null;

    if (hubs && hubs?.length) {
      const formattedHardware = hardwareUtils.formatHardware(hubs);
      dispatch(pushHardware(formattedHardware));

      nextToken = token;
    } else {
      nextToken = null;
    }
  }
};

const fetchMercuryHardware = async () => {
  let offset = 0;
  let hardwareData = [];

  while (offset !== null) {
    try {
      const result = await fetchMercuryHardwareBatch(offset);

      const data = result?.data?.data;

      if (data && data?.length) {
        const formattedHardware = hardwareUtils.formatMercuryHardware(data);
        hardwareData.push(...formattedHardware);

        offset += data?.length;
      } else {
        offset = null;
      }
    } catch (error) {
      const statusCode = error?.response?.status;
      offset = null;

      if (statusCode !== 404) {
        throw error;
      }
    }
  }

  dispatch(pushMercuryHardware(hardwareData));
};

const updateHardwareLocation = async (hubLocation) => {
  const url = getRequestData("hub/update-hub-location");

  return await httpClient.put(url, { data: hubLocation });
};

const updateLocationHardware = async (locationHubs) => {
  const url = getRequestData("hub/update-location-hubs");

  return await httpClient.put(url, { data: locationHubs });
};

const updateMercuryLocationHardware = async (locationHubs, resetRouters = false) => {
  const baseUrl = getRequestData(`router`, mercuryApiUrl);
  const url = `${baseUrl}?resetRouters=${resetRouters}`;

  return await httpClient.put(url, { data: locationHubs });
};

const createMercuryHardware = async (hardware) => {
  const url = getRequestData("router", mercuryApiUrl);

  return await httpClient.post(url, { data: hardware });
};

const hardwareService = {
  fetchHardware,
  fetchMercuryHardware,
  updateHardwareLocation,
  updateLocationHardware,
  updateMercuryLocationHardware,
  createMercuryHardware
};

export default hardwareService;
